import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PIPOn = function PIPOn(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 7C2.44772 7 2 7.44772 2 8V21C2 21.5523 2.44772 22 3 22H16C16.5523 22 17 21.5523 17 21V14.5C17 13.9477 16.5523 13.5 16 13.5C15.4477 13.5 15 13.9477 15 14.5V20H4V9H9.5C10.0523 9 10.5 8.55228 10.5 8C10.5 7.44772 10.0523 7 9.5 7H3Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.5 3.5C7.5 3.22386 7.72386 3 8 3H21C21.2761 3 21.5 3.22386 21.5 3.5V16.5C21.5 16.7761 21.2761 17 21 17H8C7.72386 17 7.5 16.7761 7.5 16.5V3.5ZM11.1544 7.32704C11.1309 6.95953 11.4095 6.67533 11.7766 6.69226L17.4142 6.95222L17.4475 12.3889C17.4497 12.7549 17.1533 13.0206 16.7854 12.9824C16.4175 12.9442 16.1174 12.6167 16.1152 12.2507L16.0955 9.0357L12.2865 12.8448C12.041 13.0902 11.6199 13.067 11.3458 12.793C11.0718 12.5189 11.0486 12.0978 11.294 11.8523L14.9795 8.16689L11.8618 8.02313C11.4946 8.0062 11.1779 7.69455 11.1544 7.32704Z",
      fill: color
    })]
  });
};
export default PIPOn;